module.exports = __webpack_public_path__ + "img/1920x700-1.b0a44dfd.jpg";